export enum AddPageOptions {
  NEW_PAGE = 'newPage',
  TEMPLATE = 'template',
  DESIGN = 'design',
}

export enum PageApplyMode {
  ADD = 'add',
  REPLACE = 'replace',
}
